"use client";
import { HStack, Heading, Icon, Box, Stack, Text, AspectRatio } from "@chakra-ui/react";
import { FaCheckCircle } from "@onemind-services-llc/react-icons-ng/fa";
import { SectionDivider } from "app/components/shared/SectionDivider";
import Image from "next/image";
import { DISASTER_RECOVERY_OPERATIONS } from "./constant";

type Props = {
  title: string;
  description: string;
  data: {
    image?: any;
    title: string;
    content: string;
  }[];
};

export const DisasterRecoveryContainer = (props: Props) => {
  const { title, description, data } = props;
  return (
    <Box data-cy="DisasterRecoveryOperations">
      {title && <SectionDivider label={title} padding={"1rem 0"} />}
      <Stack spacing={10}>
        {description && (
          <Text
            textAlign={"center"}
            maxW={"600px"}
            margin={"0 auto"}
            color={"gray.600"}
            fontSize={"xl"}
          >
            {description}
          </Text>
        )}
        <Box
          display={"flex"}
          gap={4}
          flexWrap={"wrap"}
          margin={"0 auto"}
          justifyContent={"center"}
        >
          {data.map((operation, index) => {
            const { title, content } = operation;
            return (
              <Stack
                borderColor={operation?.image ? "white" : "#aaa"}
                borderRadius="8px"
                borderWidth="1px"
                boxShadow={operation?.image ? "" : "md"}
                key={index}
                p={{ base: 4, sm: 4, md: 4 }}
                spacing={6}
                maxW={"370px"}
                justifyContent={"space-between"}
              >
                {operation?.image && (
                  <AspectRatio
                    position={"relative"}
                    ratio={1}
                    width={{ base: "full", sm: "220px", md: "300px" }}
                  >
                    <Image
                      alt={title}
                      title={title}
                      blurDataURL={
                        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/epARQABAAA//w6wAAAAAElFTkSuQmCC"
                      }
                      fill
                      placeholder="blur"
                      sizes="300px"
                      src={operation?.image}
                      style={{ borderRadius: "8px", objectFit: "contain" }}
                    />
                  </AspectRatio>
                )}
                <HStack spacing={2}>
                  {!operation?.image && <Icon as={FaCheckCircle} />}
                  <Heading
                    width={"100%"}
                    fontSize={"lg"}
                    textAlign={operation?.image ? "center" : "left"}
                  >
                    {title}
                  </Heading>
                </HStack>
                <Text color={"gray.600"}>{content}</Text>
              </Stack>
            );
          })}
        </Box>
      </Stack>
    </Box>
  );
};

const BusinessOptions = () => {
  return (
    <>
      <DisasterRecoveryContainer
        title="Get Back To Business Faster"
        data={DISASTER_RECOVERY_OPERATIONS}
        description={
          "Drive more efficient operations with automated failovers and testing, and ensure the data, applications, and critical systems are recovered when you need them in the order that you need them in."
        }
      />
    </>
  );
};

export default BusinessOptions;
